import connect from "../i18n/connect";
import { actions as alertsActions } from "../redux/modules/alerts";

const mapDispatchToProps = {
  addInfoAlert: alertsActions.addInfoAlert,
  addWarningAlert: alertsActions.addWarningAlert,
  addSuccessAlert: alertsActions.addSuccessAlert,
  addErrorAlert: alertsActions.addErrorAlert,
  hideAlert: alertsActions.hideAlert
};

export default function withAddAlert(WrappedComponent) {
  return connect(null, mapDispatchToProps, null, { forwardRef: true })(
    WrappedComponent
  );
}
